<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-10">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Client Default View</h3>
        </vs-col>
      </vs-row>
      <DataGrid :context="'ClientDefaultView'" ref="campaignsList" :columnDefs="campaignsColumnDefs" :rowData="campaignsRecords"
        :dataSource="campaignsDataSource" @goToClientUserDefaultViews="goToClientUserDefaultViews">
      </DataGrid>
    </vx-card>

  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    refreshInBulk: true,
    allCampaigns: [],
    unreviewed_campaigns: [],
    UnReviewedSalesDeveloperDataPopUp: false,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 50
      },
      {
        headerName: "Campaign",
        field: "camp_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,

        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignFieldsManagement,
    DataGrid
  },
  watch: {},
  methods: {
    goToClientUserDefaultViews(campaign){


      this.$router.push(
              "/client_user/default_views/" +
                campaign.campaign_id
            );

    }, 
    getcampaignDataSource() {
      var self = this;
      this.campaignsDataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignsForGridForPopulateData",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;
              self.allCampaigns = response_data
              console.log("Campaigns", response_data);
              if (response_data.length != 0) {
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() { },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
